module.exports = __webpack_public_path__ + "static/2017_WSC_Group_2017_Self-Managed_Superfund_Checklist-d033bdf7d4e27cb4b3071a2e4ae772a3.pdf";